import { IState } from 'legacy/lut/store'

export const selectCompetitorsSobState = (state: IState) => state.partner360.competitorsSob
